import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Alert } from '@models/alert';

@Component({
  selector: 'mdk-alert-inline',
  templateUrl: './alert-inline.component.html'
})
export class AlertInlineComponent implements OnInit {
  @Input() autoClose = true;
  @Input() autoCloseTime = 5000;
  @Input()
  public set alert(value: Alert) {
    this.alert$.next(value);
  }

  @Output() closeAlert = new EventEmitter<void>();

  currentAlert$!: Observable<Alert | null>;

  private alert$ = new BehaviorSubject<Alert | null>(null);

  ngOnInit() {
    this.currentAlert$ = this.alert$.pipe(
      tap(alert => {
        if (alert && this.autoClose) {
          setTimeout(() => {
            this.onClickClose();
          }, this.autoCloseTime);
        }
      })
    );
  }

  onClickClose() {
    this.alert$.next(null);
    this.closeAlert.emit();
  }
}
